import React, {useState,useEffect}  from "react";
import {fetchDrawStatus} from './../api'
import bridge from '@/config/JSbridge'
import styled from "styled-components";
import moment from "moment";
import { jumpTo } from '@/utils'
import bwmodel from '@/config/bwmodel'
function DescIcon ({top}) {
  const active_id = '70'
  const [status, setStatus] = useState(false)
  const overTime = moment().isAfter('2024-01-31')
  const isStorm = bwmodel.app === 'storm';
  function getDrawStatus () {
    if(overTime) {
      return
    }
    const params = {
      activityId: active_id
    }
    fetchDrawStatus(params)
      .then(res => {
        let bool = true; // 默认活动没有
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i].activityStatus !== 2 && !res.data[i].got && res.data[i].activityType !== 'INVITE_ACTIVITY') {
            bool = false; //
          }
        }
        setStatus(bool)
      })
  }
  useEffect(()=> {
    getDrawStatus();

    bridge.addRegisterHandler([{
      name: 'viewWillAppear',
      callback: () => {
        getDrawStatus();
      }
    }])
  },[])

  return (
    isStorm?
    <Card className={overTime?'': 'show'} top={top} onClick={()=> {
      jumpTo(process.env.REACT_APP_DEMAND_URL  + 'active_80')
    }}>
      <div className="name">活动集市</div>
      <div className="tips">{status?'限时抽周边/会员':'抽奖机会待使用'}</div>
    </Card>
    :""
    
  )
}

export default DescIcon;


const Card = styled.div`
  display: none;
  position: absolute;
  right: 0;
  top: ${props=> props.top? props.top : '53.0vw'};
  background: #fff;
  z-index: 100;
  width: 137px;
  height: 76px;
  background: rgb(0,0,0,0.6);
  border-radius: 10px 0px 0px 10px;
  color: white;
  font-size: 24px;
  text-align: center;

  padding: 14px 0 0px;
  transform: scale(0.5);
  transform-origin: 100% 0;
   &.show{
    display: block;
   }
  div.tips{
    padding-top: 9px;
    font-size: 16px;
    margin-top: 0;
    color: white;
  }
`


// WEBPACK FOOTER //
// ./src/views/activity_80/components/DescIcon.js